import { useMemo } from "react"
import { useInfiniteQuery } from "react-query"

import { getJobActivity } from "src/api/Service/JobActivity"

const useJobActivity = (marinaSlug, jobId) => {
  const query = useInfiniteQuery({
    queryKey: ["jobActivity", marinaSlug, jobId],
    queryFn: ({ pageParam = null }) =>
      getJobActivity(marinaSlug, jobId, { beforeCursor: pageParam }),
    getNextPageParam: (lastPage) => lastPage.nextCursor || undefined,
  })

  const entries = useMemo(
    () => query.data?.pages?.flatMap((page) => page.entries) ?? [],
    [query.data]
  )

  return {
    entries,
    isLoading: query.isLoading,
    isError: query.isError,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
  }
}

export default useJobActivity
